module.exports = "/_next/static/images/website-webapp-banner-mobile-1835741d1f44d919f240c80b46625441.webp";